/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { areaActivasGet } from '../fn/area/area-activas-get';
import { AreaActivasGet$Params } from '../fn/area/area-activas-get';
import { areaEstadoIdAreaPatch } from '../fn/area/area-estado-id-area-patch';
import { AreaEstadoIdAreaPatch$Params } from '../fn/area/area-estado-id-area-patch';
import { areaExisteGet } from '../fn/area/area-existe-get';
import { AreaExisteGet$Params } from '../fn/area/area-existe-get';
import { areaExisteInformaticaGet } from '../fn/area/area-existe-informatica-get';
import { AreaExisteInformaticaGet$Params } from '../fn/area/area-existe-informatica-get';
import { areaGet } from '../fn/area/area-get';
import { AreaGet$Params } from '../fn/area/area-get';
import { areaIdAreaPatch } from '../fn/area/area-id-area-patch';
import { AreaIdAreaPatch$Params } from '../fn/area/area-id-area-patch';
import { areaNombreInformaticaGet } from '../fn/area/area-nombre-informatica-get';
import { AreaNombreInformaticaGet$Params } from '../fn/area/area-nombre-informatica-get';
import { areaPost } from '../fn/area/area-post';
import { AreaPost$Params } from '../fn/area/area-post';

@Injectable({ providedIn: 'root' })
export class AreaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `areaGet()` */
  static readonly AreaGetPath = '/area';

  /**
   * getAll.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `areaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  areaGet$Response(params?: AreaGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return areaGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAll.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `areaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  areaGet(params?: AreaGet$Params, context?: HttpContext): Observable<any> {
    return this.areaGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `areaPost()` */
  static readonly AreaPostPath = '/area';

  /**
   * insert.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `areaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  areaPost$Response(params?: AreaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return areaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * insert.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `areaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  areaPost(params?: AreaPost$Params, context?: HttpContext): Observable<any> {
    return this.areaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `areaIdAreaPatch()` */
  static readonly AreaIdAreaPatchPath = '/area/{idArea}';

  /**
   * update.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `areaIdAreaPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  areaIdAreaPatch$Response(params: AreaIdAreaPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return areaIdAreaPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * update.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `areaIdAreaPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  areaIdAreaPatch(params: AreaIdAreaPatch$Params, context?: HttpContext): Observable<any> {
    return this.areaIdAreaPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `areaEstadoIdAreaPatch()` */
  static readonly AreaEstadoIdAreaPatchPath = '/area/estado/{idArea}';

  /**
   * updateStateByIdArea.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `areaEstadoIdAreaPatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  areaEstadoIdAreaPatch$Response(params: AreaEstadoIdAreaPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return areaEstadoIdAreaPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * updateStateByIdArea.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `areaEstadoIdAreaPatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  areaEstadoIdAreaPatch(params: AreaEstadoIdAreaPatch$Params, context?: HttpContext): Observable<any> {
    return this.areaEstadoIdAreaPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `areaActivasGet()` */
  static readonly AreaActivasGetPath = '/area/activas';

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `areaActivasGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  areaActivasGet$Response(params?: AreaActivasGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return areaActivasGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getAllActive.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `areaActivasGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  areaActivasGet(params?: AreaActivasGet$Params, context?: HttpContext): Observable<any> {
    return this.areaActivasGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `areaNombreInformaticaGet()` */
  static readonly AreaNombreInformaticaGetPath = '/area/nombre/Informática';

  /**
   * getByName.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `areaNombreInformaticaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  areaNombreInformaticaGet$Response(params?: AreaNombreInformaticaGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return areaNombreInformaticaGet(this.http, this.rootUrl, params, context);
  }

  /**
   * getByName.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `areaNombreInformaticaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  areaNombreInformaticaGet(params?: AreaNombreInformaticaGet$Params, context?: HttpContext): Observable<any> {
    return this.areaNombreInformaticaGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `areaExisteInformaticaGet()` */
  static readonly AreaExisteInformaticaGetPath = '/area/existe/Informática';

  /**
   * existByName.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `areaExisteInformaticaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  areaExisteInformaticaGet$Response(params?: AreaExisteInformaticaGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return areaExisteInformaticaGet(this.http, this.rootUrl, params, context);
  }

  /**
   * existByName.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `areaExisteInformaticaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  areaExisteInformaticaGet(params?: AreaExisteInformaticaGet$Params, context?: HttpContext): Observable<any> {
    return this.areaExisteInformaticaGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `areaExisteGet()` */
  static readonly AreaExisteGetPath = '/area/existe';

  /**
   * existByNameDiffIdArea.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `areaExisteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  areaExisteGet$Response(params?: AreaExisteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return areaExisteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * existByNameDiffIdArea.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `areaExisteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  areaExisteGet(params?: AreaExisteGet$Params, context?: HttpContext): Observable<any> {
    return this.areaExisteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
